import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaAvatarGroup from './VaAvatarGroup.vue'

export const VaAvatarGroup = withConfigTransport(_VaAvatarGroup)
